//@flow
import React, { Component, Fragment } from "react";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import CircularProgress from "@material-ui/core/CircularProgress";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import VideoCameraIcon from "@material-ui/icons/Videocam";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../types/GeneralTypes";
import type { ButtonStylesClassesType } from "../styles/buttonStyles";
import { buttonStyles } from "../styles/buttonStyles";
import { iconStyles, IconStylesClassesType } from "../styles/iconStyles";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...buttonStyles(theme),
  ...iconStyles(theme),
  halfRightMargin: {
    marginRight: "5px"
  }
});

type CameraButtonClassesType = {
  ...ButtonStylesClassesType,
  ...IconStylesClassesType,
  halfRightMargin: DictionaryType
};

type CameraButtonPropsType = {
  classes: CameraButtonClassesType,
  id?: string,
  CameraActions: Function,
  isTakeVideo: boolean,
  isDialog: boolean
};

class CameraButton extends Component<CameraButtonPropsType, *> {
  render(): React$Element<*> {
    const classes = this.props.classes;
    const isTakeVideo = this.props.isTakeVideo;

    if (!isTakeVideo) {
      return (
        <Fragment>
          <Fab
            variant="extended"
            color="primary"
            type="button"
            className={classes.lightBtn}
            onClick={this.props.CameraActions}
          >
            <PhotoCameraIcon
              className={classNames(classes.greenIcon, classes.halfRightMargin)}
            />
            Take a photo
          </Fab>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <Fab
            variant="extended"
            color="primary"
            type="button"
            className={classes.lightBtn}
            onClick={this.props.CameraActions}
          >
            <VideoCameraIcon
              className={classNames(classes.greenIcon, classes.halfRightMargin)}
            />
            Take a video
          </Fab>
        </Fragment>
      );
    }
  }
}

export default withStyles(styles)(CameraButton);
